<template>
  <modal
      :name=modalName
      :scrollable="true"
      height="80%"
      width="60%"
      class="logs-modal"
  >
    <div class="window-header">

      <a href="javascript:void(0)" class="close-modal pull-right" @click="closeWithParent"><i
          class="fa fa-times"></i></a>
    </div>
    <div class="modal-body" style="overflow: scroll; height: calc(100% - 46px)">
      <pre>{{ data }}</pre>
    </div>
    <div class="d-flex justify-content-center">
      <button type="button" @click="closeWithParent" class="btn btn-danger text-white mr-2">Ok</button>
    </div>
  </modal>
</template>

<script>

export default {
  name: 'ModalLog',
  components: {},
  emits: ['close'],
  props: {
    data: {
      type: String,
      required: true
    },
    modalName: String,
    title: {
      type: String,
      default: 'Logs data'
    }
  },
  data() {
    return {
      success: '',
    }
  },
  methods: {
    closeWithParent() {
      this.$modal.hide(this.modalName)
      this.$emit('close')
    }
  },
  mounted() {

  },
  watch: {},
  computed: {},
  created: function () {

  }
}
</script>
